import React, { useState, useRef } from 'react';
import { OpenAI } from "openai";
import { FiSend } from 'react-icons/fi';

const openai = new OpenAI({
  apiKey: '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',
  dangerouslyAllowBrowser: true,
});

const InputBox = ({ messages1, setMessages1, messages2, setMessages2, chat1, chat2 }) => {
  const [rows, setRows] = useState(1);
  const [value, setValue] = useState('');
  const inputRef = useRef();

  const handleChange = (event) => {
    const textareaLineHeight = 30;
    const previousRows = event.target.rows;
    event.target.rows = 1;
    const currentRows = Math.min(8, ~~(event.target.scrollHeight / textareaLineHeight));

    if (currentRows === previousRows) {
      event.target.rows = currentRows;
    }
    setRows(currentRows < 1 ? 1 : currentRows);
    setValue(event.target.value);
  };

  const handleSubmit = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      sendMessage(1);
      sendMessage(2);
      
      setTimeout(() => {
        setValue('');
        setRows(1);
      }, 1)
    }
  };

  const sendMessage = async (i) => {
    const message = inputRef.current.value;
    if (!message) return;
    const _messages = i === 1 ? messages1 : messages2;
    const _setMessages = i === 1 ? setMessages1 : setMessages2;
    const _chat = i === 1 ? chat1 : chat2;
    _chat.current.scrollTop = _chat.current.scrollHeight;

    const msgs = [..._messages, { text: message, sender: 'user' }];
    _setMessages(messages => msgs);

    try {
      const stream = await openai.chat.completions.create({
        model: "gpt-3.5-turbo",
        messages: [{ role: "system", content: "You are a helpful assistant." }, ...msgs.map(msg => ({role: msg.sender, content: msg.text}))],
        stream: true,
      });
      for await (const chunk of stream) {
        _setMessages(messages => [...messages, { text: chunk.choices[0]?.delta?.content || '', sender: 'assistant' }]);
        setTimeout(() => {
          _chat.current.scrollTop = _chat.current.scrollHeight;
        }, 1);
      }
    } catch (error) {
      console.error('Error during API call:', error);
    }
  };

  return (
    <div className="bg-primary relative max-w-3xl mx-auto w-full p-2">
      <textarea
        ref={inputRef}
        rows={rows}
        value={value}
        onChange={handleChange}
        onKeyDown={handleSubmit}
        className="bg-primary w-full p-4 pr-20 border-2 border-gray-600 rounded-lg resize-none outline-none"
        placeholder="Type your message..."
      />

      <button
        onClick={sendMessage}
        className="bg-gray-300 absolute my-6 h-9 bottom-0 right-6 flex items-center justify-center px-2 border-l rounded-lg border-gray-600"
      >
        <FiSend size={20} className="text-gray-700" />
      </button>
    </div>
  );
};

export default InputBox;
